var map = {
	"./img/AI -Entrepreneurshipphoto.jpg": 9090,
	"./img/AncientHistory.webp": 3938,
	"./img/Avatar.png": 123,
	"./img/BCLHP.png": 9409,
	"./img/Blue-Aesthetic-Creative-PNG-Image.png": 937,
	"./img/Blue-Aesthetic-PNG.png": 9475,
	"./img/Bunting-Map-of-the-World-around-Jerusalem-site-Keilo-Jack.jpg": 85,
	"./img/ColdWar.jpg": 8834,
	"./img/Color-Explosion.png": 885,
	"./img/Computer-Science-Foundations-photo.jpeg": 7429,
	"./img/Eitans-portfolio-page-picture.png": 4444,
	"./img/Fugitives.jpg": 3362,
	"./img/Government.jpeg": 8954,
	"./img/HotTake.jpeg": 1603,
	"./img/Nerds.jpeg": 5551,
	"./img/Policing-in-America.png": 5548,
	"./img/Skype-a-Scientist.png": 5443,
	"./img/TLLogo.svg": 2523,
	"./img/The-Secret-Teacher.webp": 2419,
	"./img/Web-Design-in-HTML-&-CSS-bottom-banner.jpeg": 1704,
	"./img/additional_criteria_img.png": 1155,
	"./img/alternative-tl-logos/Gemini_Generated_Image_1fmtsy1fmtsy1fmt.jpeg": 4039,
	"./img/alternative-tl-logos/Gemini_Generated_Image_6d3n336d3n336d3n.jpeg": 1985,
	"./img/alternative-tl-logos/Gemini_Generated_Image_gxzfskgxzfskgxzf.jpeg": 138,
	"./img/alternative-tl-logos/Gemini_Generated_Image_ncyb86ncyb86ncyb.jpeg": 5921,
	"./img/alternative-tl-logos/Gemini_Generated_Image_tm95f5tm95f5tm95.jpeg": 2796,
	"./img/alternative-tl-logos/Gemini_Generated_Image_v26e3yv26e3yv26e.jpeg": 2924,
	"./img/alternative-tl-logos/blude_grid_tl_leafy_logo.jpeg": 2457,
	"./img/alternative-tl-logos/clock_loading_img.png": 2023,
	"./img/alternative-tl-logos/controller_loading_img.png": 6495,
	"./img/alternative-tl-logos/controller_loading_img_transparent.png": 9268,
	"./img/alternative-tl-logos/food_falling_loading_img.png": 4363,
	"./img/alternative-tl-logos/jack_russell_terrier_transparent_bg.png": 647,
	"./img/alternative-tl-logos/light_teach_league_logo.jpeg": 157,
	"./img/alternative-tl-logos/light_teach_league_logo_no_bg.png": 3788,
	"./img/alternative-tl-logos/loading_child.png": 4683,
	"./img/alternative-tl-logos/loading_child_transparent.png": 1792,
	"./img/alternative-tl-logos/loading_dog.png": 4203,
	"./img/alternative-tl-logos/loading_dog_transparent.png": 9872,
	"./img/alternative-tl-logos/loading_homework.png": 7931,
	"./img/alternative-tl-logos/loading_homework_transparent.png": 7792,
	"./img/alternative-tl-logos/pizza_loading_img.png": 8071,
	"./img/alternative-tl-logos/pizza_loading_transparent.png": 4184,
	"./img/alternative-tl-logos/quiz_loading_img.png": 2008,
	"./img/alternative-tl-logos/silly_objects_loading_img.png": 681,
	"./img/alternative-tl-logos/vapor_wave_teach_league_logo.jpeg": 4397,
	"./img/alternative-tl-logos/vertical_lightbulbs.png": 7501,
	"./img/berlin-wall.jpg": 9959,
	"./img/berlinWall.jpg": 2072,
	"./img/black-death.avif": 428,
	"./img/boozy-teacher.jpg": 1952,
	"./img/bpp.jpg": 7076,
	"./img/broken-pencil.png": 4285,
	"./img/canvas-lms.svg": 2833,
	"./img/chumash-indian-pow-wow.jpg": 2192,
	"./img/class-website-banner.png": 7631,
	"./img/conspiracyboard.webp": 3627,
	"./img/contact-button.png": 5214,
	"./img/crumpled_paper.png": 5101,
	"./img/daphne-gomez.jpeg": 8992,
	"./img/diseases-image.jpg": 4297,
	"./img/dog_sitting_w_hw_transparent_bg.png": 2880,
	"./img/epics-banner.png": 8057,
	"./img/favicon.ico": 1359,
	"./img/favicon.png": 6226,
	"./img/feral-circle.jpg": 7229,
	"./img/feral.png": 5098,
	"./img/film-banner.png": 7183,
	"./img/fist-with-pencil.png": 5003,
	"./img/flammarion-engraving.jpg": 9708,
	"./img/google-gemini-icon.png": 2615,
	"./img/greek-philosophers.webp": 4517,
	"./img/group_discussions.png": 1473,
	"./img/halo.png": 6650,
	"./img/hijab.png": 6574,
	"./img/hypnotizedArmy.png": 9291,
	"./img/kisspng-green-paint-brushes-watercolor-painting-light-7-light-green-watercolor-brush-stroke-png-transpa-5cfe874fbf4a88.1910132315601846557835.png": 2328,
	"./img/laying_down_dog_transparent_bg.png": 6601,
	"./img/leaf-wallpaper.png": 3997,
	"./img/light-bulb-vector-bg.jpg": 8520,
	"./img/logo.jpg": 6833,
	"./img/logo.png": 7433,
	"./img/map.jpg": 7744,
	"./img/migration.jpg": 6786,
	"./img/mind-control-swirl1.webp": 6407,
	"./img/mising_voices_background_transparent_img.png": 9093,
	"./img/missing_voices_lab_img.png": 4110,
	"./img/moms-spaghetti.webp": 3464,
	"./img/money-vector-bg.jpg": 3354,
	"./img/na-bg.jpg": 1567,
	"./img/news.png": 9333,
	"./img/padlock_tansparent_bg.png": 4643,
	"./img/paisleyOutline.png": 8949,
	"./img/paper-wallpaper.png": 2985,
	"./img/personal-finance.png": 37,
	"./img/pirates.png": 3436,
	"./img/png-transparent-brainwashing-mobile-app-development-youtube-mind-thought-fat-man-mobile-app-development-human-body-area-thumbnail.png": 8878,
	"./img/private-vault-log.svg": 1233,
	"./img/programming-banner.png": 2774,
	"./img/progressive-democracy.png": 2415,
	"./img/r:AskHSteacher.png": 6406,
	"./img/rainbow-wallpaper.png": 713,
	"./img/rantinghomer.gif": 7463,
	"./img/read-about-eitan-button.png": 819,
	"./img/robot.jpg": 9422,
	"./img/saslogo.png": 6404,
	"./img/seamless-germs-virus-and-microbes-background-vector-16161805.webp": 8171,
	"./img/secretteacher.jpeg": 8809,
	"./img/sitting_dog_transparent_bg.png": 9538,
	"./img/statue-with-halo.jpg": 2856,
	"./img/stonehenge.png": 6796,
	"./img/students.png": 5820,
	"./img/survive-the-world-banner.png": 1246,
	"./img/tcc.png": 1772,
	"./img/teach-peoples-history.jpeg": 370,
	"./img/teach_league_vector.svg": 7571,
	"./img/teachers_share_transparent_bg.png": 6958,
	"./img/technology-photo.png": 2365,
	"./img/thought-bubble.png": 7986,
	"./img/tl-banner.png": 301,
	"./img/tl-dog-homework.png": 78,
	"./img/tl-dog-sitting-homework.png": 1179,
	"./img/tlLogo.jpeg": 8942,
	"./img/transparent-bg.png": 8714,
	"./img/triangle.svg": 5394,
	"./img/urges.jpeg": 2039,
	"./img/vapor-wave-statue.jpg": 2907,
	"./img/vaporwaveTrees.png": 7400,
	"./img/vaporwaveTrees1.png": 7731,
	"./img/vote.png": 9000,
	"./img/warm_up_generator_img.png": 7805,
	"./img/waves-boomerang-light-poster.jpg": 5760,
	"./img/world-history-photo.png": 1182,
	"./img/world-war-vctor-background.png": 6151,
	"./img/world-wars-banner.png": 5998,
	"./img/wp5004292-vaporwave-aesthetic-1920x1080-wallpapers.jpg": 9590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4366;